import latestSchema from './v7';

export default latestSchema;
